import { CommonService } from './../../services/common/common.service';
import { Router } from '@angular/router';
import { UserService } from './../../services/user/user.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { regex, WEB_USER_URL } from './../../constants/config';
import { Component, OnInit, Input, EventEmitter, Output, NgZone } from '@angular/core';
import { ApiService } from '../../services/api-service/api.service';
import { selectRequired, validateZipcode, validatePhone } from '../../services/custom-validate/custom-validate';
import { State } from '../../models/state';
import { Title } from '@angular/platform-browser';
declare const $: any;
declare const toastr: any;
@Component({
  selector: 'register-modal',
  templateUrl: './register-modal.component.html',
  styleUrls: ['./register-modal.component.scss'],
  providers: [UserService, ApiService]
})
export class RegisterModalComponent implements OnInit {

  @Input() isShow;
  @Input() state;
  @Output() onStatus = new EventEmitter();
  public maskPhone = regex.phoneNumber;
  regitserForm1: FormGroup;
  regitserForm2: FormGroup;
  selectChanged = false;
  stateChanged = false;
  listState: any = [];
  showLoginModal = false;
  userTypes = [{
    value: 0,
    name: 'Select one'
  },
  {
    value: 1,
    name: 'Lender'
  },
  {
    value: 2,
    name: 'Agent'
  }];
  showStep2 = false;

  constructor(private formBuilder: FormBuilder,
    private _user: UserService,
    private _apiService: ApiService,
    private router: Router,
    private title: Title,
    private _common: CommonService,
    private zone: NgZone) { }

  ngOnInit() {
    $('#registerModal').on('hidden.bs.modal', () => {
      this.zone.run(() => {
        this.onStatus.emit(false);
        this.showLoginModal = false;
        this.showStep2 = false;
        this.initForm1(); this.selectChanged = false;
        this.initForm2(); this.stateChanged = false;
      });
    });
    this.getListState();
    this.initForm1();
    this.initForm2();
  }

  ngOnChanges() {
    if (this.state === 'register') {
      this.showLoginModal = false;
    } else if (this.state === 'login') {
      this.showLoginModal = true;
    }
    if (this.isShow) {
      $('#registerModal').modal('show');
    }
  }

  initForm1() {
    this.regitserForm1 = this.formBuilder.group({
      advertiser_type: [0, selectRequired],
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', Validators.email],
      phone: ['', [Validators.required, validatePhone]]
    });
    this.regitserForm1.controls['advertiser_type'].valueChanges.subscribe((value) => {
      this.selectChanged = true;
    });
  }

  initForm2() {
    this.regitserForm2 = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      state_id: [0, selectRequired],
      zip_code: ['', [Validators.required, validateZipcode]],
      profile_type: ['1'],
      term_agree: [false]
    });
    this.regitserForm2.controls['state_id'].valueChanges.subscribe((value) => {
      this.stateChanged = true;
    });
  }

  nextStep() {
    if (!this.regitserForm1.valid) {
      this.selectChanged = true;
      this.markFormGroupTouched(this.regitserForm1);
      return;
    }
    this.showStep2 = true;
  }

  register() {
    if (!this.regitserForm2.valid) {
      this.stateChanged = true;
      this.markFormGroupTouched(this.regitserForm2);
      return;
    }
    if (!this.regitserForm2.value.term_agree) {
      this._common.showToastr('error', 'You must agree to our Terms of Service and Privacy Policy to continue', 'An error occured!');
      return;
    }
    const registerInfo = Object.assign(this.regitserForm1.value, this.regitserForm2.value);
    this._user.register(registerInfo).then((data: any) => {
      this.title.setTitle(`${data.first_name} ${data.last_name} Profile`);
      // this.router.navigate(['/profile']);
      this.router.navigate(['/onboard']);
      $('#registerModal').modal('hide');
    }).catch((err) => {
      console.log(err);
    });
  }

  getListState() {
    this._apiService.getListState().then((data) => {
      this.listState = data;
    }).catch((err) => {
      console.log(err);

    });
  }

  changeStatusLoginModal(status) {
    if (status) {
      this.showLoginModal = false;
      this.showStep2 = false;
    }
  }

  showTerms() {
    window.open(`${WEB_USER_URL}terms-of-service`, '_blank');
  }

  showPolicy() {
    window.open(`${WEB_USER_URL}policy`, '_blank');
  }

  markFormGroupTouched(formGroup: FormGroup) {
    return (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/register-modal/register-modal.component.ts